<template>
  <div>
    <span
      v-if="type === 'img'"
      class="file-tip"
    >圖片最多可選擇 {{ quantity }} 個檔案，每個檔案大小限 4MB 以下；檔案類型可為：jpg、jpeg、png、gif</span>
    <span
      v-if="type === 'file'"
      class="file-tip"
    >文件最多可選擇 {{ quantity }} 個檔案，每個檔案大小限 10MB 以下；檔案類型可為：doc、docx、xlsx、xls、pdf、ppt、pptx</span>
    <!-- 新增用 -->
    <input
      :id="`_${name}`"
      type="file"
      name="file[]"
      style="display: none"
      multiple="multiple"
      @change="AddFileChangeEve"
    >
    <!-- 更換用 -->
    <input
      :id="`ChangeFile_${name}`"
      type="file"
      style="display: none"
      @change="AddFileChangeEve"
    >
    <div class="file-wrap">
      <div
        v-for="(file,file_ind) in myfileArray"
        :key="file_ind"
        class="file"
      >
        <span v-if="type == 'file'">{{ file.file == '' ? file.fileName || `檔案${file_ind+1}`:file.file.name }}</span>
        <div
          v-if="type == 'img'"
          class="bg-img"
          :style="`background-image: url('${file.BS64 || file.expiringUrl || file.uploadUrl}')`"
          @click="showLightbox(file.BS64 == '' ? file.uploadUrl:file.BS64)"
        />
        <div v-if="!disabled" class="optionBtn-wrap">
          <div
            class="btn"
            @click="ChangeFile(file_ind)"
          >
            更換
          </div>
          <div
            class="btn"
            @click="delFile(file_ind)"
          >
            刪除
          </div>
        </div>
      </div>
      <div
        v-if="addFileShow() && !disabled"
        class="file file-plus"
        @click="AddFile()"
      >
        <i
          class="icon-plus"
          aria-hidden="true"
        />
        <span>新增{{ type =='img'? '圖片':'檔案' }}</span>
      </div>
    </div>
    <el-dialog
      title="檔案上傳錯誤"
      :visible.sync="alertDialog"
      width="40%"
      class="dialog"
    >
      <div class="left">
        <i
          class="icon-input-error"
          aria-hidden="true"
        />
      </div>
      <div class="right">
        <p>以下檔案不符合檔案類型或大小限制：</p>
        <div refs="alertMsg" />
        <div
          v-for="(item , index) in alertMsg"
          :key="index"
        >
          <p>{{ item }}</p>
        </div>
        <div
          v-if="type === 'file'"
          class="fileCondition"
        >
          <p>檔案類型僅允許 doc、docx、xlsx、xls、pdf、ppt、pptx</p>
          <p>每個檔案大小限 10MB 以下（不可為 0KB）</p>
        </div>
        <div
          v-else
          class="fileCondition"
        >
          <p>檔案類型僅允許 jpg、jpeg、png、gif</p>
          <p>每個檔案大小限 4MB 以下（不可為 0KB）</p>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          size="mini"
          @click="alertDialog = false"
        >確定</el-button>
      </span>
    </el-dialog>
    <lightbox
      id="mylightbox"
      ref="lightbox"
      :images="images"
    />
  </div>
</template>
<script>
export default {
  props: {
    type: '',
    filearray: Array,
    name: '',
    quantity: 0,
    disabled: false
  },
  data () {
    return {
      fileRechangeInd: -1,
      myfileArray: this.filearray,
      fileQuantity: this.quantity,
      images: [],
      alertMsg: [],
      alertDialog: false
    }
  },
  watch: {
    filearray: {
      handler (newVal, oldVal) {
        this.myfileArray = newVal
        this.images = []
        this.lightboxData()
      },
      deep: true
    },
    myfileArray: {
      handler (newVal, oldVal) {
        this.$emit('on-fileArray-change', newVal)
      },
      deep: true
    }
  },
  mounted () {
    this.lightboxData()
  },
  methods: {
    showLightbox (imageName) {
      this.$refs.lightbox.show(imageName)
    },
    lightboxData () {
      this.myfileArray.forEach(item => {
        if (item.type === 'img') {
          this.images.push({
            name: item.BS64 || item.expiringUrl || item.uploadUrl
          })
        }
      })
    },
    AddFile () {
      let ErrMsg
      console.log(this.fileQuantity)
      if (this.myfileArray.length >= this.fileQuantity) {
        // 判斷筆數
        // eslint-disable-next-line eqeqeq
        if (this.type == 'file') {
          ErrMsg = '檔案最多為' + this.fileQuantity + '筆'
        // eslint-disable-next-line eqeqeq
        } else if (this.type == 'img') {
          ErrMsg = '圖片最多為' + this.fileQuantity + '筆'
        }
        this.$alert(ErrMsg, '提示', {
          confirmButtonText: '確定',
          type: 'warning',
          callback: action => {}
        })
        return false
      }
      this.fileRechangeInd = -1
      document.getElementById(`_${this.name}`).click()
    },
    ChangeFile (ind) {
      this.fileRechangeInd = ind
      document.getElementById(`ChangeFile_${this.name}`).click()
    },
    AddFileChangeEve () {
      // eslint-disable-next-line eqeqeq
      const acceptFileType = this.type == 'file' ? ['doc', 'docx', 'xlsx', 'xls', 'pdf', 'ppt', 'pptx'] : ['jpg', 'jpeg', 'png', 'gif']
      // eslint-disable-next-line eqeqeq
      const acceptFileSize = this.type == 'file' ? 10485760 : 4194304
      let files
      if (this.fileRechangeInd === -1) // 新增檔案
      { files = document.getElementById(`_${this.name}`).files } else // 更換檔案
      { files = document.getElementById(`ChangeFile_${this.name}`).files }
      const newFiles = []
      this.alertMsg = []
      console.log(files)
      for (const file of files) {
        const fileType = file.name.split('.')[file.name.split('.').length - 1].toLowerCase()
        const filesize = file.size
        // eslint-disable-next-line eqeqeq
        if (acceptFileType.indexOf(fileType) == -1) { this.alertMsg.push(file.name) } else if (filesize > acceptFileSize) { this.alertMsg.push(file.name) } else if (filesize === 0) { this.alertMsg.push(file.name) } else { newFiles.push(file) }
      }
      if (this.alertMsg.length !== 0) { this.alertDialog = true }
      // eslint-disable-next-line eqeqeq
      if (newFiles.length > 0 && this.type == 'file') {
        if (this.fileRechangeInd === -1) {
          // 新增檔案
          for (const file of newFiles) {
            if (this.myfileArray.length < this.fileQuantity) {
              this.myfileArray.push({
                type: 'file',
                file,
                uploadUrl: ''
              })
            }
          }
          document.getElementById(`_${this.name}`).value = ''
        } else {
          // 替換檔案
          this.myfileArray[this.fileRechangeInd].file = newFiles[0]
          this.myfileArray[this.fileRechangeInd].uploadUrl = ''
          document.getElementById(`ChangeFile_${this.name}`).value = ''
        }
      // eslint-disable-next-line eqeqeq
      } else if (newFiles.length > 0 && this.type == 'img') {
        // eslint-disable-next-line eqeqeq
        if (this.fileRechangeInd == -1) {
          // 新增圖片
          for (const file of newFiles) {
            this.GetBS64(file, res => {
              if (this.myfileArray.length < this.fileQuantity) {
                this.myfileArray.push({
                  type: 'img',
                  file,
                  uploadUrl: '',
                  BS64: res
                })
              }
            })
          }
          document.getElementById(`_${this.name}`).value = ''
        } else {
          // 替換圖片
          this.myfileArray[this.fileRechangeInd].file = newFiles[0]
          this.myfileArray[this.fileRechangeInd].uploadUrl = ''
          this.GetBS64(newFiles[0], res => {
            this.myfileArray[this.fileRechangeInd].BS64 = res
          })
          document.getElementById(`ChangeFile_${this.name}`).value = ''
        }
      } else {
        document.getElementById(`_${this.name}`).value = ''
        document.getElementById(`ChangeFile_${this.name}`).value = ''
      }
    },
    delFile (ind) {
      this.myfileArray.splice(ind, 1)
    },
    GetBS64 (file, callback) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        callback(this.result)
      }
    },
    addFileShow () {
      let flag = true
      if (this.fileQuantity === undefined || this.fileQuantity === 0) { flag = true } else { flag = this.myfileArray.length < this.fileQuantity }
      return flag
    }
  }
}
</script>
<style lang="sass" scoped>
  .file-wrap
    display: flex
    .file
      width: 150px
      height: 150px
      border: 1px solid $borderDark1
      color: #666
      border-radius: 8px
      cursor: pointer
      margin: 10px
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column
      position: relative
      overflow: hidden
      &.error
        border: 1px solid #c44536
      &.success
        border: 1px solid #a5be00
      &:hover
        color: $mainFontColor
        border: 1px solid #aaa
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
        transition: .4s
        .optionBtn-wrap
          bottom: 0
      i
        font-size: 60px
      span
        font-size: 17px
        font-weight: 700
        width: 100%
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
        text-align: center
        margin-top: 10px
      .bg-img
        height: 100%
        width: 100%
        background-position: center
        background-size: cover
      .optionBtn-wrap
        display: flex
        position: absolute
        bottom: -30px
        width: 100%
        transition: .4s
        .btn
          width: 50%
          font-size: 17px
          font-weight: bold
          line-height: 30px
          text-align: center
          cursor: pointer
          background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #ededed), color-stop(97%, #dfdfdf) )
          background-color: #ededed
          &:first-child
            border-right: 1px solid #999
          &:hover
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#dfdfdf', endColorstr='#ededed')
            background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #dfdfdf), color-stop(97%, #ededed))
            background-color: #dfdfdf
    .file-plus
      border: 1px solid $mainColor
      color: $mainColor
      &:hover
        color: $mainColor
        border: 1px solid $mainColor
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
        transition: .4s
  .file-tip
    color: $subFontColor
    font-size: 14px
  ::v-deep .el-dialog
    border-radius: 4px
    .el-dialog__body
      display: flex
      padding-top: 0px
      padding-bottom: 0px
      .left
        flex: 1
        padding-top: 20px
        .icon-input-error
          font-size: 25px
          color: $dangerColor
      .right
        flex: 9
        p
          height: 25px
        .fileCondition
          margin-top: 20px
          border-top: $borderDark1 1px solid
</style>
